import { render, staticRenderFns } from "./OutreachTasksPage.vue?vue&type=template&id=681d4dde&scoped=true"
import script from "./OutreachTasksPage.vue?vue&type=script&lang=js"
export * from "./OutreachTasksPage.vue?vue&type=script&lang=js"
import style0 from "./OutreachTasksPage.vue?vue&type=style&index=0&id=681d4dde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681d4dde",
  null
  
)

export default component.exports